import { ApiError } from '@swarm/api-client';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

export const meKey = ['me'] as const;

export function createQueryClient() {
  const client: QueryClient = new QueryClient({
    // An expired session anywhere sends the user back to sign-in (the
    // protected layout reacts to the failing `me` query).
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (error instanceof ApiError && error.status === 401 && query.queryKey[0] !== meKey[0]) {
          void client.invalidateQueries({ queryKey: meKey });
        }
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        if (error instanceof ApiError && error.status === 401) {
          void client.invalidateQueries({ queryKey: meKey });
        }
      },
    }),
    defaultOptions: {
      // Offline, requests still run: the service worker answers reads from its
      // cache and the offline layer captures writes (ADR 0027).
      mutations: { networkMode: 'always' },
      queries: {
        networkMode: 'always',
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 1,
      },
    },
  });
  return client;
}

export const queryClient = createQueryClient();
